// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.empoffboardingpage-inline-1 {
  margin-bottom: 12px;
  border: 1px solid #dbeafe;
  background: #eff6ff;
}

.empoffboardingpage-inline-2 {
  font-size: 13px;
  font-weight: 600;
  color: #1d4ed8;
}

.empoffboardingpage-inline-3 {
  margin-bottom: 12px;
  border: 1px solid #fed7aa;
  background: #fff7ed;
}

.empoffboardingpage-inline-4 {
  font-size: 13px;
  font-weight: 600;
  color: #9a3412;
}

.empoffboardingpage-inline-5 {
  margin-bottom: 12px;
}

.empoffboardingpage-inline-6 {
  display: grid;
  grid-template-columns: repeat(5,minmax(0,1fr));
  gap: 8px;
  align-items: center;
}

.empoffboardingpage-inline-7 {
  display: grid;
  place-items: center;
  position: relative;
}

.empoffboardingpage-inline-8 {
  margin-bottom: 12px;
}

.empoffboardingpage-inline-9 {
  font-size: 12px;
  color: #64748b;
}

.empoffboardingpage-inline-10 {
  font-size: 12px;
  color: #94a3b8;
}

.empoffboardingpage-inline-11 {
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 10px;
  background: #f8fafc;
  white-space: pre-wrap;
  font-size: 12px;
  margin-bottom: 10px;
}

.empoffboardingpage-inline-12 {
  display: flex;
  gap: 8px;
}

.empoffboardingpage-inline-13 {
  font-size: 12px;
  color: #94a3b8;
}

.empoffboardingpage-inline-14 {
  margin-bottom: 10px;
}

.empoffboardingpage-inline-15 {
  display: grid;
  grid-template-columns: 1fr auto auto;
  gap: 8px;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #f1f5f9;
}

.empoffboardingpage-inline-16 {
  font-size: 12px;
}

.empoffboardingpage-inline-17 {
  font-size: 12px;
}

.empoffboardingpage-inline-18 {
  font-size: 12px;
}

.empoffboardingpage-inline-19 {
  font-size: 12px;
  margin-bottom: 6px;
  color: #b91c1c;
}

.empoffboardingpage-inline-20 {
  display: flex;
  gap: 8px;
}

.empoffboardingpage-inline-21 {
  margin-bottom: 12px;
}

.empoffboardingpage-inline-22 {
  font-size: 12px;
  color: #94a3b8;
}

.empoffboardingpage-inline-23 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  margin-bottom: 8px;
  font-size: 12px;
}

.empoffboardingpage-inline-24 {
  margin-bottom: 8px;
  font-size: 12px;
  color: #94a3b8;
}

.empoffboardingpage-inline-25 {
  margin-bottom: 12px;
}

.empoffboardingpage-inline-26 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #f1f5f9;
  padding: 8px 0;
  font-size: 12px;
}

.empoffboardingpage-inline-27 {
  color: #94a3b8;
}

.empoffboardingpage-inline-28 {
  padding: 0;
  overflow-x: auto;
}

.empoffboardingpage-inline-29 {
  padding: 20px;
}

.empoffboardingpage-inline-30 {
  text-align: center;
  padding: 20px;
  color: #94a3b8;
}

.empoffboardingpage-inline-31 {
  font-family: monospace;
  font-size: 11px;
}

.empoffboardingpage-dyn-1 {
  position: absolute;
  top: 14px;
  right: -50%;
  width: 100%;
  height: 2px;
  background: var(--empoffboardingpage-1-background);
  z-index: 0;
}

.empoffboardingpage-dyn-2 {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  font-size: 11px;
  font-weight: 700;
  color: #fff;
  background: var(--empoffboardingpage-2-background);
  z-index: 1;
}

.empoffboardingpage-dyn-3 {
  margin-top: 6px;
  font-size: 10px;
  color: var(--empoffboardingpage-3-color);
  text-align: center;
}

.empoffboardingpage-dyn-4 {
  margin-bottom: 12px;
  opacity: var(--empoffboardingpage-4-opacity);
}

.empoffboardingpage-dyn-5 {
  margin-bottom: 12px;
  opacity: var(--empoffboardingpage-5-opacity);
}

.empoffboardingpage-dyn-6 {
  margin-bottom: 8px;
  font-size: 12px;
  color: var(--empoffboardingpage-6-color);
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/Employee/EmpOffboardingPage.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8CAA8C;EAC9C,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,QAAQ;EACR,mBAAmB;EACnB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gCAAgC;EAChC,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,WAAW;EACX,kDAAkD;EAClD,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kDAAkD;EAClD,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,eAAe;EACf,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,wCAAwC;AAC1C","sourcesContent":[".empoffboardingpage-inline-1 {\n  margin-bottom: 12px;\n  border: 1px solid #dbeafe;\n  background: #eff6ff;\n}\n\n.empoffboardingpage-inline-2 {\n  font-size: 13px;\n  font-weight: 600;\n  color: #1d4ed8;\n}\n\n.empoffboardingpage-inline-3 {\n  margin-bottom: 12px;\n  border: 1px solid #fed7aa;\n  background: #fff7ed;\n}\n\n.empoffboardingpage-inline-4 {\n  font-size: 13px;\n  font-weight: 600;\n  color: #9a3412;\n}\n\n.empoffboardingpage-inline-5 {\n  margin-bottom: 12px;\n}\n\n.empoffboardingpage-inline-6 {\n  display: grid;\n  grid-template-columns: repeat(5,minmax(0,1fr));\n  gap: 8px;\n  align-items: center;\n}\n\n.empoffboardingpage-inline-7 {\n  display: grid;\n  place-items: center;\n  position: relative;\n}\n\n.empoffboardingpage-inline-8 {\n  margin-bottom: 12px;\n}\n\n.empoffboardingpage-inline-9 {\n  font-size: 12px;\n  color: #64748b;\n}\n\n.empoffboardingpage-inline-10 {\n  font-size: 12px;\n  color: #94a3b8;\n}\n\n.empoffboardingpage-inline-11 {\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  padding: 10px;\n  background: #f8fafc;\n  white-space: pre-wrap;\n  font-size: 12px;\n  margin-bottom: 10px;\n}\n\n.empoffboardingpage-inline-12 {\n  display: flex;\n  gap: 8px;\n}\n\n.empoffboardingpage-inline-13 {\n  font-size: 12px;\n  color: #94a3b8;\n}\n\n.empoffboardingpage-inline-14 {\n  margin-bottom: 10px;\n}\n\n.empoffboardingpage-inline-15 {\n  display: grid;\n  grid-template-columns: 1fr auto auto;\n  gap: 8px;\n  align-items: center;\n  padding: 8px 0;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.empoffboardingpage-inline-16 {\n  font-size: 12px;\n}\n\n.empoffboardingpage-inline-17 {\n  font-size: 12px;\n}\n\n.empoffboardingpage-inline-18 {\n  font-size: 12px;\n}\n\n.empoffboardingpage-inline-19 {\n  font-size: 12px;\n  margin-bottom: 6px;\n  color: #b91c1c;\n}\n\n.empoffboardingpage-inline-20 {\n  display: flex;\n  gap: 8px;\n}\n\n.empoffboardingpage-inline-21 {\n  margin-bottom: 12px;\n}\n\n.empoffboardingpage-inline-22 {\n  font-size: 12px;\n  color: #94a3b8;\n}\n\n.empoffboardingpage-inline-23 {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 8px;\n  margin-bottom: 8px;\n  font-size: 12px;\n}\n\n.empoffboardingpage-inline-24 {\n  margin-bottom: 8px;\n  font-size: 12px;\n  color: #94a3b8;\n}\n\n.empoffboardingpage-inline-25 {\n  margin-bottom: 12px;\n}\n\n.empoffboardingpage-inline-26 {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid #f1f5f9;\n  padding: 8px 0;\n  font-size: 12px;\n}\n\n.empoffboardingpage-inline-27 {\n  color: #94a3b8;\n}\n\n.empoffboardingpage-inline-28 {\n  padding: 0;\n  overflow-x: auto;\n}\n\n.empoffboardingpage-inline-29 {\n  padding: 20px;\n}\n\n.empoffboardingpage-inline-30 {\n  text-align: center;\n  padding: 20px;\n  color: #94a3b8;\n}\n\n.empoffboardingpage-inline-31 {\n  font-family: monospace;\n  font-size: 11px;\n}\n\n.empoffboardingpage-dyn-1 {\n  position: absolute;\n  top: 14px;\n  right: -50%;\n  width: 100%;\n  height: 2px;\n  background: var(--empoffboardingpage-1-background);\n  z-index: 0;\n}\n\n.empoffboardingpage-dyn-2 {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  display: grid;\n  place-items: center;\n  font-size: 11px;\n  font-weight: 700;\n  color: #fff;\n  background: var(--empoffboardingpage-2-background);\n  z-index: 1;\n}\n\n.empoffboardingpage-dyn-3 {\n  margin-top: 6px;\n  font-size: 10px;\n  color: var(--empoffboardingpage-3-color);\n  text-align: center;\n}\n\n.empoffboardingpage-dyn-4 {\n  margin-bottom: 12px;\n  opacity: var(--empoffboardingpage-4-opacity);\n}\n\n.empoffboardingpage-dyn-5 {\n  margin-bottom: 12px;\n  opacity: var(--empoffboardingpage-5-opacity);\n}\n\n.empoffboardingpage-dyn-6 {\n  margin-bottom: 8px;\n  font-size: 12px;\n  color: var(--empoffboardingpage-6-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
